import type { FaireProductEntity } from "../../entity_types/product";

export const p_vh2ymv7x3g: FaireProductEntity = {
  token: "p_vh2ymv7x3g",
  type: "product",
  name: "Italian Olivewood Aperitivo Bowls - Set of 4",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/7130eba6417c2c2acec99c80d51f6261525022865a23ef47a618312059f2a519.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c5c046a42509a4a9f46c6e39ac380edba8439cb7188ddab0417374d4764f378.jpeg",
    "https://cdn.faire.com/fastly/0ea637eaa3c14d7228ea4153e182b338e38d3301df56376fa5e4e2804562827d.jpeg",
    "https://cdn.faire.com/fastly/79c78db49a932c43e5ffdc348ad29b00c514c59da07547abd7ce821b840278b1.jpeg",
    "https://cdn.faire.com/fastly/c415059092f92d67f412f378a59756b8c7d8148c959a8667fb78cfa61b40a645.jpeg",
    "https://cdn.faire.com/fastly/0ecbdb16d79d699a11fc119446630dc16a339ede2c6c8bd56bb09f4629de91c6.jpeg",
    "https://cdn.faire.com/fastly/35954539fdc77389cb8ae4a744b8d08c09ad16d2145676c592c695a329fa98be.jpeg",
    "https://cdn.faire.com/fastly/c8ad13927f657e3379055dbef171ebe75bb23375ca987c9766d6e72ff6d270ef.jpeg",
    "https://cdn.faire.com/fastly/b3359deb0bc48abc0062034db16bc3cbf2594f8b3569b2f8ca812902b908b740.jpeg",
    "https://cdn.faire.com/fastly/0f0370978087ee443f4360a6b41476fb8be22154713db0f4f460d8a2413d9e9e.jpeg",
  ],
  priceDollars: 20,
  description:
    "Aperitivo, a.k.a happy hour, is a fundamental aspect of Italian life and culture. Unwind and discover delicious snacks and tapas while enjoying a refreshing apéritif, and catch up with friends. Made from the Italian “function first” philosophy of our artisans from Umbria, Italy, these are perfect for displaying or serving your favorite appetizer creations.\n\nCARE: \nHand wash only, occasionally coat with olive oil or mineral oil to keep wood looking its best. \n\nABOUT: \nCrafted from Umbria, Italy, our artisans use centuries-old tradition that produces unique pieces made from pure olive wood. The family preserves Italian history by using time-tested, hands-on techniques to craft heirloom-quality cookware as beautiful as it is functional. The famous Italian attention to design shines in every piece. ",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:00.710Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
